"use client";

import { useFilterContext } from "../../../providers";
import type { DefaultListFacet } from "../../../types/filters.type";
import { FilterOptionList } from "../FilterOptionList";

interface Props {
  facet: DefaultListFacet;
  isCompact?: boolean;
}

export function DefaultFilterList({ facet, isCompact }: Props) {
  const { getSelectedValues, onSelectionChange } = useFilterContext();
  const selected = getSelectedValues(facet.field);

  return (
    <FilterOptionList
      options={facet.values}
      selectedValues={selected}
      selector={facet.selector}
      isCompact={isCompact}
      onSelectionChange={(values) => onSelectionChange(facet.field, values)}
    />
  );
}
